const flatten = (arr) => {
  return arr.reduce(
    (acc, val) =>
      Array.isArray(val.options)
        ? acc.concat(flatten(val.options))
        : acc.concat(val),
    [],
  );
};

// eslint-disable-next-line import/prefer-default-export
export const getValue = (opts, val, getOptVal, isMulti, isCreatable) => {
  if (val === undefined) return undefined;

  let options = flatten(opts);

  // NOTE: It usually means that selected value is not present in options so we make sure it is
  if (val && isCreatable) {
    if (isMulti) {
      // Ensure val is an array before calling map
      const valArray = Array.isArray(val) ? val : [val];
      options = [
        ...options,
        ...valArray.map((value) => ({ value, label: value })),
      ];
    } else {
      options = [...options, { value: val, label: val }];
    }
  }

  if (val && isMulti) {
    // Ensure val is an array before calling map
    const valArray = Array.isArray(val) ? val : [val];
    return valArray
      .map((v) => options.find((o) => getOptVal(o) === v))
      .filter(Boolean);
  }

  // For single select, ensure val is not an array
  const singleVal = Array.isArray(val) ? val[0] : val;
  return options.find((o) => getOptVal(o) === singleVal);
};
